export enum KnowledgeBaseCategoryEnum {
  /** Documentation source */
  DOCUMENTATION = 'DOCUMENTATION',
  /** Helpdesk source */
  HELPDESK = 'HELPDESK',
  /** Other source */
  OTHER = 'OTHER',
  /** Course source */
  COURSE = 'COURSE',
}